/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/MaleBodyModel2.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";
import { useThree } from "@react-three/fiber";

useGLTF.preload("/MaleBodyModel2.glb");

export const MaleBodyModel2 = (props) => {
  const { nodes, materials } = useGLTF("/MaleBodyModel2.glb");
  const { gl, scene, camera } = useThree(); // Access renderer (gl), scene, and camera

  const takeScreenshot = () => {
    // gl is the WebGLRenderer instance
    gl.render(scene, camera); // Ensure the scene is rendered
    const dataURL = gl.domElement.toDataURL("image/png"); // Get the canvas content as an image

    props.setScreenshot(dataURL);

    // Trigger download
    // const link = document.createElement("a");
    // link.download = "screenshot.png";
    // link.href = dataURL;
    // link.click();
  };

  if (props.takeScreenShort) {
    setTimeout(() => {
      takeScreenshot();
    }, 1000);
  }
  return (
    <group {...props} dispose={null} scale={3} position={[5, 5, 10]}>
      <mesh
        geometry={nodes.male_ecorche.geometry}
        material={materials["Material.003"]}
        rotation={[Math.PI / 2, 0, 0]}
        position={[5, 5, 10]}
      />
    </group>
  );
};

useGLTF.preload("/MaleBodyModel2.glb");
